export default {"src":"/_next/static/media/Ribbon0.add57a4d.svg","height":100,"width":407};